// @flow

type MockEdgeAttributes = {|
  from: string,
  to: string,
  fromPosition?: string,
  toPosition?: string,
  style?: string,
|};

export type MockEdgeData = {|
  label: string,
  event?: string,
  style?: string,
|};

export type MockEdge = {|
  name: 'edge',
  attributes: MockEdgeAttributes,
  children: Array<any>,
|};

export const mockEdge = (
  attributes: MockEdgeAttributes,
  data: MockEdgeData,
): MockEdge => {
  const {label, event, style} = data;
  const children = [{name: 'Paragraph', children: [label]}];

  if (event) {
    children.push({
      name: 'Icon',
      attributes: {type: 'webhook', alt: event},
      children: [],
    });
  }
  return {
    name: 'edge',
    attributes: {...attributes, style: style || 'default'},
    children,
  };
};
